<template>
  <div class="text-center w-100">
    <h3 v-text="message"/>
    <img src="@/theme/images/loading.gif">
  </div>
</template>
<script>
export default {
  props:{
    "message":  {
      type: String,
      default: 'Loading ...'
    }
  }
}
</script>
